import { BaseSelect, Select, SelectProps } from '@app/components';
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { PromotionActionType } from '@app/common';
import React from 'react';

const columnHelper = createColumnHelper<PromotionActionType>();

export const getLabel = (type: PromotionActionType) => {
  switch (type) {
    case PromotionActionType.ADD_PACK:
      return "Ajouter un menu";
    case PromotionActionType.ADD_PRODUCT_VARIATION:
      return "Ajouter un produit";
    case PromotionActionType.ORDER_DISCOUNT_FIXED:
      return "Remise fixe sur la commande";
    case PromotionActionType.ORDER_DISCOUNT_PERCENTAGE:
      return "Remise en pourcentage sur la commande";
    case PromotionActionType.ITEMS_DISCOUNT_FIXED:
      return "Remise fixe sur article(s)";
    case PromotionActionType.ITEMS_DISCOUNT_PERCENTAGE:
      return "Remise en pourcentage sur article(s)";
  }
}

const columns = [
  columnHelper.display({
    id: 'type',
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Type
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => {
      return <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {getLabel(info.row.original)}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    },
  }),
];

export const PromotionActionSelect = ({ label = 'Type d\'action', ...props }: Omit<SelectProps<any>, 'table'>) => {
  const table = useReactTable({
    data: Object.values(PromotionActionType),
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Select
      label={label}
      table={table}
      transform={{
        accessor: (item) => item,
        value: (item) => item,
        display: (item) => getLabel(item)
      }}
      {...props} />
  );
};
